import React, { useState } from "react";
import ModalHeader from "../../shared/components/ModalHeader";
import gettext from "../../shared/utils/gettext";
import CancelButton from "../../shared/buttons/CancelButton";
import SaveButton from "../../shared/buttons/SaveButton";
import { interpolate } from "../../shared/utils/legacy";
import { Modal } from "react-bootstrap";
import { Model } from "backbone";
import { groupBy } from "../../shared/utils/javascript";
import cropr, { GeometryModel } from "../../shared/utils/cropr";
// @ts-ignore
import MultiSelect from "@kenshooui/react-multi-select";
import "@kenshooui/react-multi-select/dist/style.css";

type SortedListData = {
  id: number;
  label: string;
};

export type PropertiesModalProps = {
  farmContact: Model;
  selectedObjects: any;
  show: boolean;
  onChange?: any;
};

const CropFieldPermissionSelectModal = ({
  farmContact,
  selectedObjects,
  show,
  onChange = () => {},
}: PropertiesModalProps) => {
  const [showModal, setShowModal] = useState(show);

  const selectedPlanIds =
    selectedObjects && selectedObjects.plan ? selectedObjects.plan.map((plan: any) => plan.id) : [];
  const selectedPlans = cropr.plans
    .filter((plan) => {
      return selectedPlanIds.length
        ? selectedPlanIds.some((planId: number) => plan.id === planId)
        : true;
    })
    .sort((a, b) => (a.get("period_end") > b.get("period_end") ? -1 : 1));

  const [searchValue, setSearchValue] = useState("");
  const [selectedPlan, setSelectedPlan] = useState(selectedPlans[0].id);
  const [selectedCropFieldIds, setSelectedCropFieldIds] = useState(
    selectedObjects && selectedObjects.crop_f
      ? selectedObjects.crop_f.map((plan: any) => plan.id)
      : []
  );
  const selectedCropFields = cropr.all_cropfields
    .filter((cropfield) => {
      return selectedCropFieldIds.some((cropfieldId: number) => cropfield.id === cropfieldId);
    })
    .sort((a, b) => (a.get("name") > b.get("name") ? -1 : 1));

  const selectedPlanCropfieldIds: number[] = [];
  const otherSelectedCropfieldIds: number[] = [];
  const allCropfields = cropr.all_cropfields.map((cf, i) => {
    const selected =
      selectedCropFields.filter((selectedCropfield) => selectedCropfield.id === cf.id).length > 0;
    cf.set({ selected: selected });
    if (selected) {
      if (cf.get("plan") === parseInt(selectedPlan)) {
        selectedPlanCropfieldIds.push(cf.id);
      } else {
        otherSelectedCropfieldIds.push(cf.id);
      }
    }
    return cf;
  });
  const allCropfieldsByPlan = groupBy(allCropfields, (cf: any) => cf.get("plan"));
  const selectedCropfieldsByPlan = groupBy(selectedCropFields, (cf: any) => cf.get("plan"));

  const selectedPlanCropfields: SortedListData[] = [];
  const selectedCropfieldsOfPlan = selectedCropfieldsByPlan.get(parseInt(selectedPlan)) || [];
  selectedCropfieldsOfPlan.forEach((cropfield: GeometryModel) => {
    selectedPlanCropfields.push({
      id: cropfield.id,
      label:
        cropfield.get("name") + (cropfield.get("crop") ? " (" + cropfield.get("crop") + ")" : ""),
    });
  });

  const allPlanCropfields: SortedListData[] = [];
  allCropfields.forEach((cropfield: GeometryModel) => {
    const label =
      cropfield.get("name") + (cropfield.get("crop") ? " (" + cropfield.get("crop") + ")" : "");
    if (
      cropfield.get("plan") === parseInt(selectedPlan) &&
      label.toLowerCase().includes(searchValue.toLowerCase())
    ) {
      allPlanCropfields.push({
        id: cropfield.id,
        label: label,
      });
    }
  });
  const closeModal = () => {
    setShowModal(false);
  };

  const handleChangePlan = (e: any) => {
    setSelectedPlan(e.target.value);
  };

  return (
    <Modal className="modal-md dfi-modal" show={showModal} onHide={closeModal} data-backdrop={true}>
      <ModalHeader title={gettext("Select cropfields access")} />
      <Modal.Body>
        <div className="row">
          <div className="col-12"></div>
          <div className="col-12 mb-1">
            <span>
              {interpolate(gettext("Grant access to cropfields for user %s"), [
                farmContact.get("name"),
              ])}
            </span>
          </div>
          <div className="col-12">
            <div className="py-3">
              <h5 className="py-1">{gettext("Selected plan(s)")}</h5>
              <select className="custom-select w-50" onChange={handleChangePlan}>
                {selectedPlans.map((plan, i) => (
                  <option key={i} value={plan.id}>
                    {plan.get("name")} (
                    {selectedCropfieldsByPlan.get(plan.id)
                      ? selectedCropfieldsByPlan.get(plan.id).length
                      : 0}
                    /
                    {allCropfieldsByPlan.get(plan.id) ? allCropfieldsByPlan.get(plan.id).length : 0}
                    )
                  </option>
                ))}
              </select>
            </div>
            <div className="custom-multi-select-box">
              <h5 className="py-1 w-50 mr-2 d-inline-block">
                {gettext("Cropfields available")} (
                {(allCropfieldsByPlan.get(parseInt(selectedPlan))
                  ? allCropfieldsByPlan.get(parseInt(selectedPlan)).length
                  : 0) -
                  selectedCropFieldIds.filter(
                    (cropfieldId: number) => !otherSelectedCropfieldIds.includes(cropfieldId)
                  ).length}
                )
              </h5>
              <h5 className="py-1 w-40 d-inline-block">
                {gettext("Selected cropfields")} (
                {
                  selectedCropFieldIds.filter(
                    (cropfieldId: number) => !otherSelectedCropfieldIds.includes(cropfieldId)
                  ).length
                }
                )
              </h5>
              <MultiSelect
                messages={{
                  searchPlaceholder: gettext("Search") + "...",
                  noItemsMessage: gettext("No Items") + "...",
                  noneSelectedMessage: gettext("None Selected"),
                  selectedMessage: gettext("selected"),
                  selectAllMessage: gettext("Select All"),
                  clearAllMessage: gettext("Clear All"),
                  disabledItemsTooltip: gettext("You can only select 1 file"),
                }}
                items={allPlanCropfields}
                selectedItems={selectedPlanCropfields}
                onChange={(sortedList: any) => {
                  setSelectedCropFieldIds([
                    ...otherSelectedCropfieldIds,
                    ...sortedList.map((i: { id: any }) => i.id),
                  ]);
                }}
                // searchValue={searchValue}
                searchValueChanged={(value: any) => setSearchValue(value)}
              />
            </div>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-outline-smoke mx-3 d-block"
                onClick={() =>
                  setSelectedCropFieldIds([
                    ...otherSelectedCropfieldIds,
                    ...allCropfieldsByPlan.get(parseInt(selectedPlan)).map((cf: any) => cf.id),
                  ])
                }
              >
                {gettext("Select all")}
              </button>
              <button
                className="btn btn-outline-danger mx-3 d-block"
                onClick={() => setSelectedCropFieldIds(otherSelectedCropfieldIds)}
              >
                {gettext("Remove all")}
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <CancelButton onClick={closeModal} />
        <SaveButton
          onClick={() => {
            closeModal();
            onChange(selectedCropFieldIds);
          }}
        >
          {gettext("Ok")}
        </SaveButton>
      </Modal.Footer>
    </Modal>
  );
};

export default CropFieldPermissionSelectModal;
